import { useContext } from "react";
import {
    LayersSideBarContext,
    SearchSideBarContext,
    SideBarContextData,
    SearchSideBarCemeteryContext,
} from "../contexts/side-bars.context";

export function useLayersSideBar(): SideBarContextData {
    const context = useContext(LayersSideBarContext);

    if (!context) {
        throw new Error(
            "useLayersSideBar must be used within an SideBarProvider"
        );
    }

    return context;
}

export function useSearchSideBar(): SideBarContextData {
    const context = useContext(SearchSideBarContext);

    if (!context) {
        throw new Error(
            "useSearchSideBar must be used within an SideBarProvider"
        );
    }

    return context;
}

export function useSearchSideBarCemetery(): SideBarContextData {
    const context = useContext(SearchSideBarCemeteryContext);

    if (!context) {
        throw new Error(
            "useSearchSideBarCemetery must be used within an SideBarProvider"
        );
    }

    return context;
}
